import React, { useState } from 'react';
import clsx from 'clsx';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Fade, ListItem, ListItemIcon, ListItemText, Tooltip } from '@mui/material';
import useStyles from './styles';
import { NavObject } from '../../../../globals/nav-list';
import { AppState } from '../../../../store';
import { testIsOrbcomm, testIsPL161 } from '../../../../globals/utils';

type menuItem = {
  active: boolean;
  navItem: NavObject;
  open: boolean;
  uri: string;
};

const MenuItem = ({ active, navItem, open, uri }: menuItem) => {
  const classes = useStyles();
  const selectedEntity = useSelector((state: AppState) => state.search.selectedEntity);
  const deviceType = selectedEntity?.deviceType;
  const deviceKey = selectedEntity?.deviceKey;
  const isOrbcommDevice = testIsOrbcomm(deviceType);
  const isPL161 = testIsPL161(deviceType);
  const disabledMessage = 'Page not accessible for searched device type';
  const isDisabled = navItem.uri === '/configure' && (isOrbcommDevice || isPL161 || !deviceKey);
  const iconStrokeColor = active ? '#FFCC11' : '#A7B0C0';

  const [visible, setVisible] = useState(false);

  return (
    <>
      <Link
        id={`side-nav-link-${navItem.title.toLocaleLowerCase()}`}
        style={{ textDecoration: 'none', color: 'white' }}
        to={uri}
        className={isDisabled ? classes.linkDisabled : ''}
      >
        <ListItem
          button
          disabled={isDisabled}
          className={clsx(classes.listContainer, {
            [classes.activeContainer]: active,
          })}
        >
          <Tooltip
            title={isDisabled ? disabledMessage : navItem.title}
            placement="right"
            arrow
            open={visible}
            onClose={() => setVisible(false)}
            onOpen={() => {
              if (!open) setVisible(true);
            }}
            TransitionComponent={Fade}
            TransitionProps={{ timeout: 600 }}
          >
            <ListItemIcon className={classes.iconContainer}>
              <>{navItem.icon && navItem.icon({ stroke: iconStrokeColor })}</>
            </ListItemIcon>
          </Tooltip>
          <ListItemText
            className={clsx(classes.listItemText, {
              [classes.activeLink]: active,
              [classes.inactiveText]: !active,
            })}
            primary={navItem.title}
          />
        </ListItem>
      </Link>
    </>
  );
};

export default MenuItem;
